import LimitDefinitionList from './LimitDefinitionList';
import LimitDefinitionEdit from './LimitDefinitionEdit';

const limitDefinitions = {
	list: LimitDefinitionList,
	edit: LimitDefinitionEdit
};

export default limitDefinitions;
